<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData"  ref="form" label-width="130px"
        v-loading="loading">

        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="deviceName" label="设备名称">
         {{ formData.deviceName||'--' }}
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="currentStatus" label="当前状态">
              <el-tag type="success" v-if="formData.currentStatus == '1'">闲置</el-tag>
            <el-tag   v-if="formData.currentStatus == '2'">运行</el-tag>
            <el-tag type="danger" v-if="formData.currentStatus == '3'">维护</el-tag>

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="checkResult" label="检查结果">
              <el-tag type="success" v-if="formData.checkResult == '1'">正常</el-tag>
            <el-tag type="danger" v-if="formData.checkResult == '2'">异常</el-tag>

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="manager" label="管理人">
              {{ formData.managerName||'--' }}

          </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="remark" label="备注">
              {{ formData.remark||'--' }}

          </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <div class="row-wrap" v-if="$attachmentFiles(formData.fileList).length>0">

                <div class="images-wrap" v-for="(item, index) of $attachmentFiles(formData.fileList)" :key="index">
                  <el-image style="width: 100%; height: 100%" :src="item.filePrefix + item.fileUrl"
                    :preview-src-list="fileImgUrl" fit="cover" />
                </div>

              </div>
              <div style="color:#999" v-else>暂无</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'equipmentLedgerAdd',

  data () {
    return {
      formData: {
        deviceId: '',
        currentStatus: '',
        manager: '',
        managerName: '',
        checkResult: '',
        remark: '',
        fileList: []
      },

      loading: false

    }
  },
  created () {
    if (this.recordId) {
      this.loadData()
    }
  },
  computed: {
    recordId () {
      return this.$route.query.recordId
    },
    fileImgUrl () {
      const arr = this.$attachmentFiles(this.formData.fileList).map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.equipmentLedger.selectPaEquipmentLedgerByRecordId, {
          params: { recordId: this.recordId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }

  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
